import React, { useContext, useState } from 'react'
import classNames from 'classnames'

import { CallVideoPopup } from 'components/Popups'
import { UiContext } from 'context/ui'
import { POPUPS_ID } from 'utils/constants'
import { DashboardSearch } from 'components/Dashboard'

import TalksMessage from './TalksMessage'
import { useHistory } from 'react-router-dom'

const getTransctriptions = (calls) => {
  let transcriptions = []
  calls.forEach((chat) => {
    if (chat.transcription) {
      try {
        const parsedTranscription = JSON.parse(chat.transcription)
        transcriptions.push({ transcription: parsedTranscription, id: chat.id })
      } catch (error) {
        // Ignore malformed payloads instead of evaluating untrusted input.
      }
    }
  })
  return transcriptions
}

const TalksList = (props) => {
  const listClasses = classNames('talks_list', {
    limit_mod: props.limitMod,
  })
  const history = useHistory()

  const [isSearchActive, setIsSearchActive] = useState(false)

  const transcriptions = getTransctriptions(props.calls)

  const { activePopupId, activeChatVideo, setActiveChatVideo } = useContext(UiContext)

  const handleTalkClick = (chat) => {
    const redirectUrl = `/summary/group/${chat.id}`
    history.push(redirectUrl)
  }

  const parsedCalls = props.calls.filter((call) => call?.meeting_notes?.length > 0)

  return (
    <>
      <DashboardSearch
        transcriptions={transcriptions}
        setIsSearchActive={setIsSearchActive}
        isOpen={true}
        chats={parsedCalls}
        onResultClick={(chat) => {
          handleTalkClick(chat)
        }}
      />
      {activePopupId !== POPUPS_ID.chat && !isSearchActive && (
        <ul className={listClasses}>
          {parsedCalls.length === 0 && (
            <li className="talks_no_previous">
              No previous {props.type === 'events' ? 'events' : 'calls'}
            </li>
          )}
          {parsedCalls.map((chat, index) => {
            const recordedCall = props.recordedCalls?.find(
              (call) => call.room_name === chat.room_name
            )

            return (
              <React.Fragment key={chat.id}>
                <li className="talks_list_item">
                  <TalksMessage
                    chat={chat}
                    schedule={props.schedule}
                    reschedule={props.reschedule}
                    recordedCall={recordedCall}
                    onRecordedCallClick={(callVideoLink) => {
                      handleTalkClick(chat)
                      if (callVideoLink) {
                        setActiveChatVideo(callVideoLink)
                      }
                    }}
                  />
                </li>
                {index < parsedCalls.length - 1 && <hr className="talks_divider" />}
              </React.Fragment>
            )
          })}
        </ul>
      )}
      <CallVideoPopup
        isOpen={activePopupId === POPUPS_ID.callVideo}
        videoLink={activeChatVideo}
      />
    </>
  )
}

export default TalksList
